import i18n from '@/plugins/i18n'

export default [
    {
        path: '/' + i18n.t('plan-proposal.routes.index') + '/:customer_id',
        name: 'plan-proposal.index',
        child: false,
        component: () =>
            import(
                /* webpackChunkName: "plan-proposal" */ '@/views/plan-proposals/Index.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('plan-proposal.breadcrumbs.index'),
                    to: {
                        name: 'plan-proposal.index',
                        params: { customer_id: 'customer_id' },
                    },
                    disable: false,
                },
            ],
            showName: i18n.t('plan-proposal.breadcrumbs.index'),
        },
        props: true,
    },
    {
        path: '/' + i18n.t('plan-proposal.routes.create') + '/:customer_id',
        name: 'plan-proposal.create',
        child: true,
        component: () =>
            import(
                /* webpackChunkName: "plan-proposal" */ '@/views/plan-proposals/Create.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('plan-proposal.breadcrumbs.index'),
                    to: {
                        name: 'plan-proposal.index',
                        params: { customer_id: 'customer_id' },
                    },
                    disable: false,
                },
                {
                    text: i18n.t('plan-proposal.breadcrumbs.create'),
                    to: {
                        name: 'plan-proposal.create',
                        params: { customer_id: 'customer_id' },
                    },
                    disable: true,
                },
            ],
        },
        props: true,
    },
    {
        path: '/' + i18n.t('plan-proposal.routes.show') + '/:id',
        name: 'plan-proposal.show',
        child: true,
        component: () =>
            import(
                /* webpackChunkName: "plan-proposal" */ '@/views/plan-proposals/Show.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('plan-proposal.breadcrumbs.index'),
                    to: {
                        name: 'plan-proposal.index',
                        params: { customer_id: 'customer_id' },
                    },
                    disable: false,
                },
                {
                    text: i18n.t('plan-proposal.breadcrumbs.show'),
                    to: {
                        name: 'plan-proposal.show',
                        params: { id: 'id' },
                    },
                    disable: true,
                },
            ],
        },
        props: true,
    },
]
